import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4b56eb54"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "claim__title" }
const _hoisted_2 = { class: "claim__text" }
const _hoisted_3 = { class: "claim__text claim__text--gray" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "claim__label" }, "Check your Ethereum address", -1))

import WhiteWrapper from "@/components/white-wrapper/index.vue";
import ClaimAddressInput from "./components/claim-address-input.vue";
import ClaimEnkryptBanner from "./components/claim-enkrypt-banner.vue";
import ClaimValidAccount from "./components/claim-valid-account.vue";
import ClaimInvalidAccount from "./components/claim-invalid-account.vue";
import ButtonsBlock from "@/components/buttons-block/index.vue";
import BaseButton from "@/components/base-button/index.vue";
import { Account } from "@/types/account";
import { computed, ref, watch } from "vue";
import { useRouter } from "vue-router";
import {
  apiPromise,
  nativeToken,
  shouldOpenWalletSelector,
  walletSelected,
} from "@/stores";
import { isAddress } from "web3-utils";
import createIcon from "@/libs/identicon/ethereum";
import { BN_ZERO } from "@polkadot/util";
import type { Option } from "@polkadot/types";
import type { BalanceOf } from "@polkadot/types/interfaces";
import BigNumber from "bignumber.js";
import { fromBase } from "@/utils/units";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const router = useRouter();

const account = ref<Account>();
const address = ref<string>("");
const isValid = ref<boolean>(false);
const isLoading = ref<boolean>(false);
const claimable = ref<BigNumber>(new BigNumber(0));

watch(account, async () => {
  if (account.value) {
    try {
      isLoading.value = true;
      const api = await apiPromise.value;

      const claims = await api.query.claims.claims<Option<BalanceOf>>(
        account.value.address
      );
      claimable.value = new BigNumber(
        fromBase(
          claims.unwrapOr(BN_ZERO).toString(),
          nativeToken.value.decimals
        )
      );
      isValid.value = claimable.value.gt(0);

      isLoading.value = false;
    } catch (err) {
      console.error(
        "Unexpected error when querying if account has claimable balance",
        err
      );
      isLoading.value = false;
    }
  }
});

const addressInput = (newVal: string) => {
  const trimmed = newVal.trim();
  address.value = trimmed;
  const isValidAddress = isAddress(trimmed);
  account.value = isValidAddress
    ? {
        id: Number.MAX_SAFE_INTEGER,
        name: "",
        image: createIcon(trimmed),
        address: trimmed,
        isLedger: false,
      }
    : undefined;
};

const nextAction = () => {
  router.push({
    name: "claiming",
    query: {
      ethAddress: account.value?.address,
    },
  });
};

const connectWallet = () => {
  shouldOpenWalletSelector.value = true;
};

const isConnected = computed(() => walletSelected.value.id !== 1);
const tokenSymbol = computed(() =>
  nativeToken.value.symbol.toLocaleUpperCase()
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(WhiteWrapper, { class: "claim__wrap" }, {
      default: _withCtx(() => [
        _createElementVNode("h2", _hoisted_1, " Claim " + _toDisplayString(tokenSymbol.value) + " tokens for Ethereum presale address ", 1),
        _createElementVNode("p", _hoisted_2, " This claims process only applies to " + _toDisplayString(tokenSymbol.value) + " (old) that were purchased in the form of " + _toDisplayString(tokenSymbol.value) + " Allocation Indicators on Ethereum before June 30, 2020. ", 1),
        _createElementVNode("p", _hoisted_3, " If you bought your " + _toDisplayString(tokenSymbol.value) + " tokens more recently or from another source, this process does not apply to you. You do not need to claim. ", 1),
        _hoisted_4,
        _createVNode(ClaimAddressInput, {
          account: account.value,
          value: address.value,
          "onUpdate:address": addressInput
        }, null, 8, ["account", "value"]),
        (!isLoading.value && isValid.value)
          ? (_openBlock(), _createBlock(ClaimValidAccount, {
              key: 0,
              token: _unref(nativeToken),
              amount: claimable.value.toNumber()
            }, null, 8, ["token", "amount"]))
          : _createCommentVNode("", true),
        (account.value && !isLoading.value && !isValid.value)
          ? (_openBlock(), _createBlock(ClaimInvalidAccount, { key: 1 }))
          : _createCommentVNode("", true),
        _createVNode(ButtonsBlock, null, {
          default: _withCtx(() => [
            (isConnected.value)
              ? (_openBlock(), _createBlock(BaseButton, {
                  key: 0,
                  disabled: isLoading.value || !isValid.value,
                  title: "Continue",
                  action: nextAction,
                  send: true
                }, null, 8, ["disabled"]))
              : (_openBlock(), _createBlock(BaseButton, {
                  key: 1,
                  title: "Connect wallet to claim",
                  action: connectWallet
                }))
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(WhiteWrapper, { class: "claim__wrap claim__wrap--second" }, {
      default: _withCtx(() => [
        _createVNode(ClaimEnkryptBanner)
      ]),
      _: 1
    })
  ], 64))
}
}

})